(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.adminReferencePoints', {
                    requireLogin: true,
                    url: 'admin/referencePoints',
                    templateUrl: 'app/admin/referencePoints/referencePoints.html?app_v=deployDate',
                    data: {
                        authorizedRoles: ['Administrator'],
                        navMarker: ['admin', 'referencePoints']
                    },
                    controller: 'referencePointsCtrl'
                })
        }]);
})();